import getConfig from 'next/config';

import buildAuthorizationHeader from './helpers/buildAuthorizationHeader';

/**
 * @param {DeepLOptions} options
 * @returns {*}
 */

export const getTranslationLanguages = (options) => {
  const { publicRuntimeConfig } = getConfig();
  if (typeof document !== 'undefined') {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': options.language,
      Authorization: buildAuthorizationHeader(document.cookie),
    };

    return fetch(publicRuntimeConfig.translationLanguagesUrl, {
      method: 'GET',
      headers,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'OK' && res.data.languages) {
          return res.data.languages;
        }
        return [];
      });
  }
  return false;
};
